// extracted by mini-css-extract-plugin
export default {"container":"Video_container__J0JYw","video":"Video_video__6GwTG","title":"Video_title__KYFXn","video_footer":"Video_video_footer__090+n","icon":"Video_icon__K3EOb"};